import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

export enum PbZonenActions{
  None = 0,
  ShowDetail = 1,
  CopyBestellUrl = 2,
  Duplicate = 3,
  Archive = 4,
  ShowPb = 5
}

@Injectable()
export class PbZonenData {
  data: any;
  added_ids: any;
  public selectedZonenAction: PbZonenActions;

  constructor(public http: Http, public common: CommonData
    , public userData: UserData
    ) {
    this.added_ids = [];
    this.selectedZonenAction = PbZonenActions.None;
    this.data = [];
    this.load();
  }
  clear(){
    if(this.data!=null){
      this.data.length = 0;
    }
  }

  load() {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        var data = JSON.stringify({
          token: this.userData.jwt
      });
        this.http.post(this.common.baseurl+'pbzonen/index',data).subscribe(res => {
          this.data = res.json().data;
          //console.log(this.data);
          resolve(this.data);
        }, error => {
          console.log('HTTP Error, no answer pbzonen-data.ts');
          console.log(error);
      });

      }
    });
  }

  view(pbzonen_id) {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        let params = JSON.stringify({ 
          pbzonen_id: pbzonen_id
          ,token: this.userData.jwt
        });            

        this.http.post(this.common.baseurl+'pbzonen/view',params).subscribe(res => {
          let data = res.json().data;
          resolve(data);
        }, error => {
          console.log('HTTP Error, no answer view pbzonen-data.ts');
          //console.log(error);
      });

      }
    });
  }  

  create(pbzone){
    return new Promise(resolve => {
      //console.log(pbzone);
      let params = JSON.stringify({ 
        pbzone: pbzone
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'pbzonen/create',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){   
              //console.log(response.data.id);
              this.added_ids.push(response.data.id);
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });   
  }
  update(pbzone){
    return new Promise(resolve => {
      //console.log(pbzone);
      let params = JSON.stringify({ 
        pbzone: pbzone
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'pbzonen/update',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){   
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });   
  }
  delete(pbzone){
    return new Promise(resolve => {

    });
  }

  archivieren(pbzone_id){
    return new Promise(resolve => {
      //console.log(pbzone);
      let params = JSON.stringify({ 
        pbzone_id:pbzone_id
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'pbzonen/archive',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){   
            resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });   
  }
  copy(pbzone_id){
    return new Promise(resolve => {        
      let params = JSON.stringify({ 
        token: this.userData.jwt,
        pbzone_id: pbzone_id
      });    

      this.http.post(this.common.baseurl+'pbzonen/copy',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){
              resolve(response.data);         
          }
          else{  
            resolve(false);
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);
      });
    }); 
  }

  namebyid(pbzone_id){
    //console.log(ppid);
    let i=0;
    for(i=0; i<this.data.length; i++){
      if(this.data[i].id == pbzone_id){
        //console.log(this.data[i].kurzname);
        return this.data[i].name;                
      }
    }
    return pbzone_id;    
  }
}



// WEBPACK FOOTER //
// ./src/providers/pbzonen-data.ts